<template>
  <form>
    <base-card>
      <product-image :image="targetItem.image" @setImage="setImage" class="two" />
      <base-input :label="StringLanguage.productName" v-model="targetItem.name" />
      <base-textarea :label="`${StringLanguage.ingredients} / ${StringLanguage.description}`" v-model="targetItem.description" rows="4" />
      <div class="half-cols mt_15">
        <base-input :label="StringLanguage.value" v-model="targetItem.price" class="m_0 pr-7 flex" :money-mask="StringLanguage.currencyConfigs" />
        <base-input :label="StringLanguage.promo" v-model="targetItem.originalPrice" class="m_0 pl-7 flex" :money-mask="StringLanguage.currencyConfigs" />
      </div>
    </base-card>

    <!-- Disponibilidade -->
    <base-availability
      name="do produto"
      :availability="targetItem.availability"
      @updateAvailability="updateAvailability"
    ></base-availability>
    <!-- fim Disponibilidade -->
  </form>
</template>
<script>
import ProductImage from "@/containers/Catalog/ProductImage"
import Builder from "@/plugins/core/schema/components/Builder.js";
import { Money } from "v-money";
import { getXAPIEnv } from '@/plugins/account'

import BaseCard from '@/components/Card'
import BaseInput from '@/components/Input'
import BaseButton from '@/components/Button'
import BaseTextarea from '@/components/Textarea'

import StringTemplate from 'easyjs/lib/Tools/StringTemplate'
import BaseAvailability from "@/containers/Availability";

export default {
  components: {
    //UploadImage,
    ProductImage,
    BaseCard,
    BaseInput,
    BaseButton,
    BaseTextarea,
    BaseAvailability
  },
  data() {
    return {
      StringTemplate,
      targetItem: Builder.factory("Simple"),
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false
      },
      deleteMode: {
        main: false
      },
    };
  },
  props: {
    originCatalog: {}
  },
  computed: {
    environment() {
      return getXAPIEnv();
    },
  },
  methods: {
    updateAvailability(newAvailability) {
      Vue.set(this.targetItem, "availability", newAvailability);
    },
    setImage(fileName){
      this.targetItem.image = fileName
    },
    setModel(item, parent) {
      this.cleanModel()
      this.targetItem = item || Builder.factory('Simple');
      this.targetItem.parent_ref = parent
      this.targetItem.parent = parent._id || null

        if (this.targetItem.originalPrice > this.targetItem.price) {
          let aux = this.targetItem.price;
          this.targetItem.price = this.targetItem.originalPrice;
          this.targetItem.originalPrice = aux;
        }
    },
    cleanModel() {
      for (let key of Object.keys(this.deleteMode)) {
        this.deleteMode[key] = false;
      }
    },
    deleteItem() {
      this.targetItem.delete = true;
      this.$emit('saveItem', this.targetItem)
    },
    getItem() {
      this.cleanModel()
      return this.targetItem
    }
  }
};
</script>
<style scoped>
  .half-cols {display: flex; justify-content: space-between}
  .pr-7 {padding-right: 7.5px}
  .pl-7 {padding-left: 7.5px}
</style>